import axios from 'axios';
import app from '@/main'

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    }
});
//console.log(store.getters.isLoggedIn);
//console.log(123456);

httpClient.interceptors.request.use(config => {
    app.config.globalProperties.$loading.value = true
    return config
})

httpClient.interceptors.response.use(response => {
        app.config.globalProperties.$loading.value = false
        return response
    },
    error => {
        app.config.globalProperties.$loading.value = false
        /*if (error.response.status === 401) {
            store.dispatch('logout');
        }*/
        return Promise.reject(error);
    });
export default httpClient;